import Label from "components/form/label";
import ColorSwatch from "components/color-swatch/color-swatch";
import * as React from "react";
import { $, merge } from "glamor";
import { theme } from "styles/theme";
import { formatMessage } from "lib/globalize-util";
import type { IScope } from "reducers/scope";
import { getSwatch, getSwatchLabel } from "helpers/swatch-utils";
import { IProduct } from "records/item/item";

interface ISelectedColorProps {
    item: IProduct;
    scope: IScope;
}

export class SelectedColor extends React.PureComponent<ISelectedColorProps, any> {
    private styles = merge(
        {
            marginTop: "16px",
            marginBottom: "10px",
        },
        $(" .colorSwatchContainer", {
            display: "flex",
            alignItems: "center",
            border: `1px solid ${theme.palette.borderColor}`,
            borderRadius: "4px",
            marginBottom: "6px",
            padding: "10px",
        }),
        $(" .colorSwatchContainer .swatchContainer", {
            height: "36px !important",
            width: "36px !important",
            marginRight: "10px !important",
        }),
        $(" .colorSwatchContainer .swatch", {
            height: "28px !important",
            width: "28px !important",
        }),
        $(" .colorLabel", {
            fontSize: "15px",
        })
    );

    render() {
        const { item, scope } = this.props;
        const hasSwatches = scope?.brand?.modules?.base?.color_swatches?.length > 0;
        return (
            <div {...this.styles}>
                <Label>{formatMessage("Selected Color")}</Label>
                {hasSwatches && (
                    <div className="colorSwatchContainer">
                        <ColorSwatch item={item} swatch={getSwatch(item, scope)} />
                        <span className="colorLabel">{getSwatchLabel(item, scope)}</span>
                    </div>
                )}
                {!hasSwatches && <div className="colorLabel">{item.color}</div>}
            </div>
        );
    }
}
